export const parseParams = (params: {
  fiscalYear?: string;
  skipAdministrativeReformTeamEvaluation?: string;
}) => {
  const { fiscalYear, skipAdministrativeReformTeamEvaluation, ...rest } =
    params;

  return {
    ...rest,
    ...(fiscalYear && fiscalYear !== 'all' && { fiscalYear }),
    ...(skipAdministrativeReformTeamEvaluation &&
      skipAdministrativeReformTeamEvaluation !== 'all' && {
        skipAdministrativeReformTeamEvaluation,
      }),
  };
};
